import { HttpService } from '@/infra/http'
import type { TTipoProdutoEnum } from '@/types/produto'

import type { TGetConfiguracoesPrecoResponse } from './get-configuracoes-preco.service'

export type TGetProdutoDisponivelNovaSimulacaoResponse = TGetConfiguracoesPrecoResponse // NOSONAR

export class GetProdutoDisponivelNovaSimulacaoService extends HttpService {
  execute = async (idExternoProduto: number, idExternoBloco: number, tipoDoProduto?: TTipoProdutoEnum) => {
    return this.http.get<TGetProdutoDisponivelNovaSimulacaoResponse>(
      `api/v2/Produto/${idExternoProduto}/bloco/${idExternoBloco}/disponivelNovaSimulacao`,
      { params: { tipoDoProduto } },
    )
  }
}
